<template>
    <v-tooltip top>
        <a slot="activator" @click="$emit('excluir')" class="icone">
            <i class="fas fa-trash-alt" aria-hidden="true"/>
        </a>
        Excluir
    </v-tooltip>
</template>

<script>
export default {
    name: 'BotaoExcluir',
    props: ['id']
}
</script>

<style scoped lang="stylus">
    @media (max-width 720px)
        .icone i
            font-size 18px
</style>
